import {h, Component} from 'preact'
import {HomepageElement, Container21HomepageElement} from '../homepage'
import WidgetColumn from './widget-column'

interface Props {
  parentEl: HTMLElement,
  homepageElement: Container21HomepageElement,
  onChildEnter: () => void,
  onChildLeave: () => void,
  onChange: (change: ElementChange) => void
}

interface State {
  editingId: string | null,
  column_1: Container21HomepageElement['config']['column_1'],
  column_2: Container21HomepageElement['config']['column_2'],
}

const assignIds = (el: HomepageElement, idx: number) => Object.assign({}, el, {id: idx})


export type ElementChange = Pick<HomepageElement, 'type' | 'config' | 'title'>

export type DonePayload = {idx: number, element: ElementChange}
export type MovePayload = {direction: 'up' | 'down'}
export type VisiblePayload = boolean

export default class ContainerEditor extends Component<Props, State> {
  constructor(props: Props) {
    super()

    this.state = {
      editingId: null,
      column_1: props.homepageElement.config.column_1.map(assignIds),
      column_2: props.homepageElement.config.column_2.map(assignIds),
    }
    this.fireOnChange= this.fireOnChange.bind(this)
  }

  fireOnChange() {
    this.props.onChange({
      type: 'container_2_1',
      config: {
        column_1: this.state.column_1,
        column_2: this.state.column_2,
      }
    })
  }

  render({ homepageElement }: Props, {column_1, column_2}: State) {
    return <div>
      <WidgetColumn
        container={`.homepage-widget-container--index-${homepageElement.id} .homepage-widget-container--container-2-1-column_1`}
        classPrefix='homepage-widget-container--container-2-1-column_1-index-'
        elements={column_1}
        widgetList={[{
          type: 'html_widget',
          title: 'HTML widget',
          description: 'Custom widget by HTML'
        }]}
        onChange={(column_1: Container21HomepageElement['config']['column_1']) => this.setState({column_1}, this.fireOnChange)}
        onChildMouseOut={this.props.onChildLeave}
        onChildMouseOver={this.props.onChildEnter}
        nested
      />

      <WidgetColumn
        container={`.homepage-widget-container--index-${homepageElement.id} .homepage-widget-container--container-2-1-column_2`}
        widgetList={[{
          type: 'html_widget',
          title: 'HTML widget',
          description: 'Custom widget by HTML'
        }, {
          type: 'badges',
          title: 'Awarded Badges widget',
          description: 'A list of users that recently received a badge' 
        }, {
          type: 'tag_cloud',
          title: 'Tag cloud',
          description: 'A cloud of your most used tags'
        }, {
          type: 'solved_topics',
          title: 'Solved Topics',
          description: 'A list of topics with a best answer assigned'
        }, {
          type: 'most_liked',
          title: 'Most liked',
          description: 'A list of users that received the most likes'
        }, {
          type: 'community_statistics',
          title: 'Community Statistics',
          description: 'Shows community wide statistics'
        }]}
        classPrefix='homepage-widget-container--container-2-1-column_2-index-'
        elements={column_2}
        onChange={(column_2: Container21HomepageElement['config']['column_2']) => this.setState({column_2}, this.fireOnChange)}
        onChildMouseOut={this.props.onChildLeave}
        onChildMouseOver={this.props.onChildEnter}
        nested
      />
    </div>
  }
}
